import { useEffect, useState } from "react";
import { SpendCategory } from "../types/VendorTypes";
import { getCategories } from "./api/UserClient";
import { handleError } from "./ErrorHandling";

// One request for the app's lifetime, shared by every caller: a list of
// project rows mounts many at once. A taxonomy change shows up on reload.
let request: Promise<SpendCategory[] | null | undefined> | undefined;

/**
 * The org's own project category taxonomy: undefined while it loads, null
 * when the org has none (then nothing category-related is shown).
 */
export function useOrgCategories(): SpendCategory[] | null | undefined {
    const [categories, setCategories] = useState<SpendCategory[] | null | undefined>(undefined);

    useEffect(() => {
        if (!request) {
            request = getCategories()
                .then((res) => res.categories ?? null)
                .catch((error) => {
                    request = undefined; // retry on the next mount
                    handleError(error);
                    return undefined;
                });
        }
        let cancelled = false;
        void request.then((result) => {
            if (!cancelled) setCategories(result);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    return categories;
}
